// ─────────────────────────────────────────────────────────────────────────────
// History feature — API давхарга. Хүргэгдсэн/дууссан захиалгын жагсаалт.
// ─────────────────────────────────────────────────────────────────────────────
import AxiosRequest from "shared/api/httpClient";

/** Захиалгын түүх (статус/огноогоор). */
export async function fetchOrders({
  statusIds = [],
  startDate,
  endDate,
  page,
  limit,
}) {
  return AxiosRequest({
    url: "/merchant/fetchOrders",
    method: "post",
    data: { statusIds, startDate, endDate, page, limit },
  });
}
